import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import ServiceTypeList, { DispatchProps, OwnProps, StateProps } from './ServiceTypeListScreen';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import { getServiceTypes } from 'src/store/actions/service-type-actions';
import { selectNameProviders } from '../../../../../../store/selectors/providers-selectors';
import { getProvidersSmall } from '../../../../../../store/actions/provider-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.serviceTypes.data,
        inProgress: state.serviceTypes.inProgress,
        providers: selectNameProviders(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getProviders: (params: QueryParams) => dispatch(getProvidersSmall(params)),
        getData: (params: QueryParams) => dispatch(getServiceTypes(params)),
    };
}

const ServiceTypeListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(ServiceTypeList);

export default ServiceTypeListScreen;
